export const PAGE_BREAKPOINTS = {
  XXL: 1232,
  XL: 1200,
  LG: 992,
  BLOCKS_LG: 960,
  MD: 768,
  SM: 576
};

export enum TOAST_VARIANT {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  NONE = 'none'
}

export enum BUTTON_VARIANTS {
  PRIMARY = 'primary',
  CONTRAST = 'contrast',
  GHOST = 'ghost',
  DANGER = 'danger'
}

export enum BUTTON_SIZES {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg'
}

export enum DropdownPosition {
  AUTO = 'auto',
  BOTTOM_START = 'bottom-start',
  BOTTOM_END = 'bottom-end',
  TOP_END = 'top-end',
  TOP_START = 'top-start'
}

export enum DropdownSize {
  LG = 'lg',
  MD = 'md',
  SM = 'sm'
}

export const DEFAULT_DATE_FORMAT = 'MM/dd/yy';
export const DATE_FORMAT_OMM = 'yyyy/MM/dd';

export const NEW_STATE = 'new';

export const IN_APP = 'inApp';
